module.exports = __webpack_public_path__ + "img/portfolio-05.5acfd231.jpg";